import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { actionCreators } from '../actions';

const getBuyerFooterClient = async ({ node, store, relayEnv }) => {
    const isMobile = serverVars.get('settings.isMobile');

    let navPromise;
    let messageBannerPromise = Promise.resolve({});

    if (!isMobile) {
        navPromise = import(
            /* webpackChunkName: "responsiveFooter" */ '../components/responsiveFooter'
        );
    } else {
        navPromise = import(/* webpackChunkName: "mobileFooter" */ '../components/mobileFooter');

        messageBannerPromise = import(
            /* webpackChunkName: "MobileFooterMessageBanner" */ '../components/MessageBanner/MobileFooterMessageBanner'
        );
    }

    const { FooterRenderer, footerInitialVariables, footerRootQuery } = await navPromise;
    const { default: MobileFooterMessageBanner } = await messageBannerPromise;

    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');

    if (MobileFooterMessageBanner) {
        const div = document.createElement('div');
        div.className = 'footer-message-banner';
        node.parentNode.insertBefore(div, node.nextSibling);
        render(
            <IntlProvider locale={localeDataKey} messages={messages}>
                <Provider store={store}>
                    <MobileFooterMessageBanner environment={relayEnv} />
                </Provider>
            </IntlProvider>,
            div
        );
    }

    hydrate(
        <IntlProvider locale={localeDataKey} messages={messages}>
            <Provider store={store}>
                <FooterRenderer
                    environment={relayEnv}
                    initialVariables={footerInitialVariables}
                    query={footerRootQuery}
                />
            </Provider>
        </IntlProvider>,
        node
    );

    return {
        updateUserState: store.dispatch.bind(null, actionCreators.setUpdateUserState(true)),
    };
};

export { getBuyerFooterClient };
